import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'covidTrackingSearchfilter'
})
export class CovidTrackingSearchfilterPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    items = items.filter(item => item.nameOfVacine.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.firstShotCompletedDate.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.secondShotDate.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.displayName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.secondShotCompletedDate.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.alreadyHaveCovid.toLowerCase().indexOf(filter.toLowerCase()) !== -1 );
    return items;
  }

}
